export default __webpack_public_path__ + "static/media/cooper-electric.a2377d09.png";